import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellOrganizationBillingType: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TableCellOrganizationBillingType' };

import { computed } from '@vue';

import type { Organization } from '@models';

/**
 * `TableCellOrganizationBillingType` component properties.
 */
export interface Props {
  /** ... */
  item: Organization;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  /** ... */
  item: Organization;
};



const value = computed(() => props.item.billingType);

const licensingMethod = computed(() => props.item.licensingMethod);

const style = computed(() => {
  if (value.value === 'SiteLicense') {
    return {
      color: '#372920',
      backgroundColor: '#ecb38e',
    };
  }

  if (value.value === 'BillMeLater') {
    return {
      color: '#202c37',
      backgroundColor: '#85b7e4',
    };
  }

  if (value.value === 'POT') {
    return {
      color: '#372a36',
      backgroundColor: '#ecb8e8',
    };
  }

  if (value.value === 'StudentPays') {
    return {
      color: '#32372a',
      backgroundColor: '#dbefbc',
    };
  }

  return {
    color: '#272727',
    backgroundColor: '#dcdcdc',
  };
});

return { __sfc: true,props, value, licensingMethod, style }
}

})